import { DEPENDENCY } from "../constants/ActionTypes";

const initialState = {
    GOOGLE_ANALYTICS: false,
    SENSOR: false
};

export default function (state = initialState, action = {}) {
    let GOOGLE_ANALYTICS = action.GOOGLE_ANALYTICS;
    let SENSOR = action.SENSOR;
    switch (action.type) {
        case DEPENDENCY.GOOGLE_ANALYTICS:
            return Object.assign({}, state, {
                GOOGLE_ANALYTICS
            });
        case DEPENDENCY.SENSOR:
            return Object.assign({}, state, {
                SENSOR
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/dependency.js